import React from 'react';
import styles from '../Assets/NewHeroSection.module.css';
import DesktopBanner from "../Assets/img/manual-banner-desk.webp";
import MobileBanner from "../Assets/img/manual-banner-mobile.webp";
import { useTranslation } from 'react-i18next';
import LocalizedLink from '../../../../Components/LocalizedLink'; // Path apne project structure ke hisaab se adjust kar lein

import { GiDiamondRing } from "react-icons/gi";
import { TfiLocationPin } from "react-icons/tfi";
import { SlDiamond } from "react-icons/sl";
import { MdOutlinePrecisionManufacturing } from "react-icons/md";
import { GoShieldCheck } from "react-icons/go";
import { IoIosArrowRoundForward } from "react-icons/io";

const features = [
    {
        id: 1,
        titleKey: 'hero.feature1Title',
        subtitleKey: 'hero.feature1Subtitle',
        icon: <SlDiamond />,
    },
    {
        id: 2,
        titleKey: 'hero.feature2Title',
        subtitleKey: 'hero.feature2Subtitle',
        icon: <MdOutlinePrecisionManufacturing />,
    },
    {
        id: 3,
        titleKey: 'hero.feature3Title',
        subtitleKey: 'hero.feature3Subtitle',
        icon: <GiDiamondRing />,
    },
    {
        id: 4,
        titleKey: 'hero.feature4Title',
        subtitleKey: 'hero.feature4Subtitle',
        icon: <TfiLocationPin />,
    },
    {
        id: 5,
        titleKey: 'hero.feature5Title',
        subtitleKey: 'hero.feature5Subtitle',
        icon: <GoShieldCheck />,
    },
];

const NewBanner = () => {
    const { t } = useTranslation();

    return (
        <section className={styles.heroSection}>
            {/* Responsive Background Images */}
            <picture className={styles.bgPicture}>
                <source media="(max-width: 991px)" srcSet={MobileBanner} />
                <img
                    src={DesktopBanner}
                    alt="Manuel Spinosa Diamond Ring"
                    className={styles.bgImage}
                />
            </picture>

            {/* Main Content Area */}
            <div className={styles.contentContainer}>
                <div className={styles.heroContent}>
                    {/* Mobile Brand Header */}
                    <div className={styles.mobileBrandHeader}>
                        <span className={styles.brandTitle}>SPINOSA</span>
                        <span className={styles.brandSubtitle}>{t('hero.since1958')}</span>
                        <span className={styles.brandDivider}></span>
                    </div>

                    {/* Desktop Subhead */}
                    <div className={styles.desktopSince}>
                        <span className={styles.line}></span>
                        <span className={styles.sinceText}>{t('hero.since1958').toUpperCase()}</span>
                        <span className={styles.line}></span>
                    </div>

                    {/* Main Headings */}
                    <h1 className={styles.mainHeading}>
                        <span className={styles.headingBlack}>{t('hero.headingPart1')}</span>
                        <span className={styles.headingGold}>{t('hero.headingPart2')}</span>
                    </h1>

                    <p className={styles.description}>
                        {t('hero.descriptionLine1')}<br className={styles.desktopBr} />
                        {t('hero.descriptionLine2')}
                    </p>

                    {/* Localized Link Navigation */}
                    <LocalizedLink to="/engagement-rings" style={{ textDecoration: 'none' }}>
                        <button type="button" className={styles.ctaButton}>
                            <span>{t('hero.ctaButton')}</span>
                            <span className={styles.arrow}><IoIosArrowRoundForward /></span>
                        </button>
                    </LocalizedLink>
                </div>
            </div>

            {/* Bottom Features Strip */}
            <div className={styles.bottomBar}>
                <div className={styles.bottomBarInner}>
                    {features.map((item, index) => (
                        <div key={item.id} className={styles.featureItem}>
                            <div className={styles.featureIcon}>{item.icon}</div>
                            <div className={styles.featureDetails}>
                                <h4 className={styles.featureTitle}>{t(item.titleKey)}</h4>
                                <p className={styles.featureSubtitle}>{t(item.subtitleKey)}</p>
                            </div>
                            {index !== features.length - 1 && <span className={styles.separator} />}
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default NewBanner;